import Vue from "vue";
import VueRouter from "vue-router";
import { storage } from "@/utils/util";
Vue.use(VueRouter);

const routes = [{
        path: "/", //首页
        component: (resolve) => require(["@/views/home/index.vue"], resolve),
        meta: {
            title: "首页",
        },
    },
    {
        path: "/home", //首页
        component: (resolve) => require(["@/views/home/index.vue"], resolve),
        meta: {
            title: "首页",
        },
    },
    {
        path: "/home1", //首页
        component: (resolve) => require(["@/views/home/index_copy.vue"], resolve),
        meta: {
            title: "首页",
        },
    },
    {
        path: "/login", //登录页
        component: (resolve) => require(["@/views/login/index.vue"], resolve),
        meta: {
            title: "登录页",
        },
    },
    {
        path: "/sidebar", //关联客户-侧边栏
        component: (resolve) => require(["@/views/sidebar/index.vue"], resolve),
        meta: {
            title: "关联客户",
        },
    },
    {
        path: "/sidebar/list", //关联客户列表
        component: (resolve) => require(["@/views/sidebar/list.vue"], resolve),
        meta: {
            title: "关联客户列表",
        },
    },
    {
        path: "/sidebar/detail", //关联客户详情
        component: (resolve) => require(["@/views/sidebar/detail.vue"], resolve),
        meta: {
            title: "关联客户详情",
            toBack: true,
        },
    },
    {
        path: "/follow/add", //客户跟进添加
        component: (resolve) =>
            require(["@/views/sidebar/components/followAdd.vue"], resolve),
        meta: {
            title: "跟进添加",
            toBack: true,
        },
    },
    {
        path: "/complaint/list", //客户投诉
        component: (resolve) => require(["@/views/complaint/list.vue"], resolve),
        meta: {
            title: "客户投诉",
            toBack: true,
        },
    },
    {
        path: "/complaint/detail", //投诉详情
        component: (resolve) => require(["@/views/complaint/detail.vue"], resolve),
        meta: {
            title: "投诉详情",
            toBack: true,
        },
    },
    {
        path: "/customer/list", //客户列表
        component: (resolve) => require(["@/views/customer/list.vue"], resolve),
        meta: {
            title: "客户列表-统计",
            toBack: true,
        },
    },
    {
        path: "/customer/customerList", //客户列表
        component: (resolve) => require(["@/views/customer/customerList.vue"], resolve),
        meta: {
            title: "客户列表-统计",
            toBack: true,
        },
    },
    {
        path: "/customer/detail", //客户详情
        component: (resolve) => require(["@/views/customer/detail.vue"], resolve),
        meta: {
            title: "客户详情",
            toBack: true,
        },
    },
    {
        path: "/customer/followers", //客户撞单跟进人信息
        component: (resolve) => require(["@/views/customer/followers.vue"], resolve),
        meta: {
            title: "撞单跟进人信息",
            toBack: true,
        },
    },
    {
        path: "/customer/follow/list", //跟进列表
        component: (resolve) =>
            require(["@/views/customer/follow/list.vue"], resolve),
        meta: {
            title: "跟进列表",
            toBack: true,
        },
    },
    {
        path: "/customer/follow/detailList", //跟进列表
        component: (resolve) =>
            require(["@/views/customer/follow/detailList.vue"], resolve),
        meta: {
            title: "跟进列表",
            toBack: true,
        },
    },
    {
        path: "/customer/follow/add", //跟进添加
        component: (resolve) =>
            require(["@/views/customer/follow/add.vue"], resolve),
        meta: {
            title: "跟进添加",
            toBack: true,
        },
    },
    {
        path: "/customer/contract/detail", //合同详情
        component: (resolve) =>
            require(["@/views/customer/components/contractDetail.vue"], resolve),
        meta: {
            title: "合同详情",
            toBack: true,
        },
    },
    {
        path: "/customer/contract/detail2", //合同详情
        component: (resolve) =>
            require(["@/views/customer/components/contractDetail.vue"], resolve),
        meta: {
            title: "合同详情",
            toBack: true,
        },
    },
    {
        path: "/fissionTask/list", //裂变任务列表
        component: (resolve) => require(["@/views/fissionTask/list.vue"], resolve),
        meta: {
            title: "裂变任务列表",
            toBack: true,
        },
    },
    {
        path: "/fissionTask/detail", //裂变任务详情
        component: (resolve) =>
            require(["@/views/fissionTask/detail.vue"], resolve),
        meta: {
            title: "裂变任务详情",
            toBack: true,
        },
    },
    {
        path: "/marketTask/list", //营销任务列表
        component: (resolve) => require(["@/views/marketTask/list.vue"], resolve),
        meta: {
            title: "营销任务列表",
            toBack: true,
        },
    },
    {
        path: "/marketTask/detail", //营销任务详情
        component: (resolve) => require(["@/views/marketTask/detail.vue"], resolve),
        meta: {
            title: "营销任务详情",
            toBack: true,
        },
    },
    {
        path: "/marketTask/info", //营销消息详情
        component: (resolve) => require(["@/views/marketTask/info.vue"], resolve),
        meta: {
            title: "营销消息详情",
            toBack: true,
        },
    },
    {
        path: "/sopTask/list", //sop任务列表
        component: (resolve) => require(["@/views/sopTask/list.vue"], resolve),
        meta: {
            title: "sop任务列表",
            toBack: true,
        },
    },
    {
        path: "/sopTask/detail", //sop任务详情
        component: (resolve) => require(["@/views/sopTask/detail.vue"], resolve),
        meta: {
            title: "sop任务详情",
            toBack: true,
        },
    },
    {
        path: "/script/list", //话术列表
        component: (resolve) => require(["@/views/script/list.vue"], resolve),
        meta: {
            title: "话术列表",
            toBack: true,
        },
    },
    {
        path: "/script/detail", //话术详情
        component: (resolve) => require(["@/views/script/detail.vue"], resolve),
        meta: {
            title: "话术详情",
            toBack: true,
        },
    },
    {
        path: "/information/list", //营销资讯列表
        component: (resolve) => require(["@/views/information/list.vue"], resolve),
        meta: {
            title: "营销资讯列表",
            toBack: true,
        },
    },
    {
        path: "/information/detail", //营销资讯详情
        component: (resolve) =>
            require(["@/views/information/detail.vue"], resolve),
        meta: {
            title: "营销资讯详情",
            toBack: true,
        },
    },
    {
        path: "/information/case", //营销资讯详情
        component: (resolve) => require(["@/views/information/case.vue"], resolve),
        meta: {
            title: "客户案例详情",
            toBack: true,
        },
    },
    {
        path: "/reminder/list", //催单列表
        component: (resolve) => require(["@/views/reminder/list.vue"], resolve),
        meta: {
            title: "催单列表",
            toBack: true,
        },
    },
    {
        path: "/reminder/detail", //催单详情
        component: (resolve) => require(["@/views/reminder/detail.vue"], resolve),
        meta: {
            title: "催单详情",
            toBack: true,
        },
    },
    {
        path: "/material/list", //营销物料
        component: (resolve) =>
            require(["@/views/sidebar/components/materialInfo.vue"], resolve),
        meta: {
            title: "营销物料",
            toBack: true,
        },
    },
    {
        path: "/material/article/down", //营销物料
        component: (resolve) =>
            require(["@/views/sidebar/components/materialInfo/ArticleQrCode.vue"], resolve),
        meta: {
            title: "二维码下载",
            toBack: true,
        },
    },
    {
        path: "/install/list", //施工安装列表
        component: (resolve) => require(["@/views/install/list.vue"], resolve),
        meta: {
            title: "施工安装列表",
            toBack: true,
        },
    },
    {
        path: "/install/detail", //施工安装详情
        component: (resolve) => require(["@/views/install/detail.vue"], resolve),
        meta: {
            title: "施工安装详情",
            toBack: true,
        },
    },
    {
        path: "/service/list", //售后列表
        component: (resolve) => require(["@/views/service/list.vue"], resolve),
        meta: {
            title: "售后列表",
            toBack: true,
        },
    },
    {
        path: "/service/detail", //售后详情
        component: (resolve) => require(["@/views/service/detail.vue"], resolve),
        meta: {
            title: "售后详情",
            toBack: true,
        },
    },
    {
        path: "/contract/list", //合同列表
        component: (resolve) => require(["@/views/contract/contractList.vue"], resolve),
        meta: {
            title: "合同列表",
            toBack: true,
        },
    },
    {
        path: "/contract/statistic", //合同列表
        component: (resolve) => require(["@/views/contract/statisticList.vue"], resolve),
        meta: {
            title: "合同统计",
            toBack: true,
        },
    },
    {
        path: "/contract/addNew", //合同列表
        component: (resolve) => require(["@/views/contract/addContract/AddContract.vue"], resolve),
        meta: {
            title: "合同下单",
            toBack: true,
        },
    },
    {
        path: "/contract/detail", //合同详情
        component: (resolve) => require(["@/views/contract/detail.vue"], resolve),
        meta: {
            title: "合同详情",
            toBack: true,
        },
    },
    {
        path: "/course/index", //课程列表
        component: (resolve) => require(["@/views/course/index.vue"], resolve),
        meta: {
            title: "课程列表",
            toBack: true,
        },
    },
    {
        path: "/course/exam", //课程列表
        component: (resolve) => require(["@/views/course/exam.vue"], resolve),
        meta: {
            title: "课程考试",
            toBack: true,
        },
    },

    {
        path: "/course/list", //课程目录
        component: (resolve) => require(["@/views/course/list.vue"], resolve),
        meta: {
            title: "课程目录",
            toBack: true,
        },
    },
    {
        path: "/course/detail", //课程详情
        component: (resolve) => require(["@/views/course/detail.vue"], resolve),
        meta: {
            title: "课程详情",
            toBack: true,
        },
    },
    {
        path: "/course/plan", //课程计划
        component: (resolve) => require(["@/views/course/plan.vue"], resolve),
        meta: {
            title: "课程计划",
            toBack: true,
        },
    },
    {
        path: "/mine", //我的
        component: (resolve) => require(["@/views/mine/index.vue"], resolve),
        meta: {
            title: "我的",
        },
    },
    // {
    //     path: "/activity/list", //活动
    //     component: (resolve) =>
    //         require(["@/views/sidebar/components/activity.vue"], resolve),
    //     meta: {
    //         title: "活动",
    //     },
    // },
    {
        path: "/activity/list", //活动
        component: (resolve) =>
            require(["@/views/activity/saleActivity.vue"], resolve),
        meta: {title: "活动列表", toBack: true},
    },
    {
        path: "/activity/sale-activity/detail", //活动
        component: (resolve) =>
            require(["@/views/activity/saleActivityDetail.vue"], resolve),
        meta: {title: "活动详情", toBack: true},
    },
    {
        path: "/activity/detail", //活动
        component: (resolve) =>
            require(["@/views/sidebar/components/activityDetail.vue"], resolve),
        meta: {
            title: "活动详情",
            toBack: true,
        },
    },
    {
        path: "/activity/luckyDetail", //活动
        component: (resolve) =>
            require(["@/views/activity/LuckActivityDetail.vue"], resolve),
        meta: {
            title: "抽奖活动",
            toBack: true,
        },
    },
    {
        path: "/activity/info", //活动
        component: (resolve) =>
            require(["@/views/sidebar/components/activityInfo.vue"], resolve),
        meta: {
            title: "详情",
            toBack: true,
        },
    },
    {
        path: "/activity/msg", //活动
        component: (resolve) =>
            require(["@/views/sidebar/components/activityMsg.vue"], resolve),
        meta: {
            title: "详情",
            toBack: true,
        },
    },
    {
        path: "/activity/form", //表单
        component: (resolve) =>
            require(["@/views/activity/question/questionFormDetail.vue"], resolve),
        meta: {
            title: "详情",
            toBack: true,
        },
    },
    {
        path: "/activity/form/result", //表单,填写情况
        component: (resolve) =>
            require(["@/views/activity/question/questionFormDetailResult.vue"], resolve),
        meta: {
            title: "详情",
            toBack: true,
        },
    },
    {
        path: "/statistic/list", //数据大盘
        component: (resolve) =>
            require(["@/views/sidebar/statistic/statisticData.vue"], resolve),
        meta: {
            title: "数据大盘",
            toBack: true,
        },
    },
    {
        path: "/myInfo/qrCode", //二维码
        component: (resolve) =>
            require(["@/views/mine/myQrCode.vue"], resolve),
        meta: {
            title: "二维码",
            toBack: true,
        },
    },
    {
        path: "/customer/sea", //客户公海统计
        component: (resolve) =>
            require(["@/views/customer/sea/seaList.vue"], resolve),
        meta: {
            title: "客户公海统计",
            toBack: true,
        },
    },
    {
        path: "/customer/sea/list", //客户公海列表
        component: (resolve) =>
            require(["@/views/customer/sea/customerList.vue"], resolve),
        meta: {
            title: "客户公海列表",
            toBack: true,
        },
    },
    {
        path: "/college/list", //商学院
        component: (resolve) =>
            require(["@/views/college/collegeList.vue"], resolve),
        meta: {
            title: "商学院",
            toBack: true,
        },
    },
    {
        path: "/college/detail", //商学院
        component: (resolve) =>
            require(["@/views/college/CollegeDetail.vue"], resolve),
        meta: {
            title: "课程",
            toBack: false,
        },
    },
    {
        path: "/college/exam", //商学院
        component: (resolve) =>
            require(["@/views/college/CollegeExam.vue"], resolve),
        meta: {
            title: "考试",
            toBack: true,
        },
    },
    {
        path: "/college/examResult", //商学院
        component: (resolve) =>
            require(["@/views/college/CollegeExamResult.vue"], resolve),
        meta: {
            title: "考试成绩",
            toBack: false,
        },
    },
    {
        path: "/college/examList", //商学院
        component: (resolve) =>
            require(["@/views/college/CollegeExamList.vue"], resolve),
        meta: {
            title: "考试记录",
            toBack: true,
        },
    },
    {
        path: "/college/categoryList", //商学院
        component: (resolve) =>
            require(["@/views/college/components/CollegeCategoryList.vue"], resolve),
        meta: {
            title: "分类查询",
            toBack: true,
        },
    },
    {
        path: "/college/teacherList", //商学院
        component: (resolve) =>
            require(["@/views/college/components/CollegeTeacherList.vue"], resolve),
        meta: {
            title: "讲师列表",
            toBack: true,
        },
    },
    {
        path: "/college/teacherDetail", //商学院
        component: (resolve) =>
            require(["@/views/college/components/CollegeTeacherDetail.vue"], resolve),
        meta: {
            title: "讲师详情",
            toBack: true,
        },
    },
    {
        path: "/college/myClass", //商学院
        component: (resolve) =>
            require(["@/views/college/components/CollegeMyClass.vue"], resolve),
        meta: {
            title: "学习记录",
            toBack: false,
        },
    },
    {
        path: "/customer/followPlan", //跟进计划
        component: (resolve) =>
            require(["@/views/customer/followPlan/FollowPlanList.vue"], resolve),
        meta: {
            title: "跟进计划",
            toBack: true,
        },
    },
    {
        path: "/customer/FollowPlanEmployee", //跟进计划个人
        component: (resolve) =>
            require(["@/views/customer/followPlan/FollowPlanEmployee.vue"], resolve),
        meta: {
            title: "跟进计划",
            toBack: true,
        },
    },
    {
        path: "/contract/quotation", //方案报价， 侧边栏加参数 sidebar=1
        component: (resolve) =>
            require(["@/views/contract/quotation/QuotationList.vue"], resolve),
        meta: {
            title: "报价方案",
            toBack: true,
        },
    },
    {
        path: "/contract/quotation/detail", //方案报价
        component: (resolve) =>
            require(["@/views/contract/quotation/QuotationDetail.vue"], resolve),
        meta: {
            title: "报价方案",
            toBack: true,
        },
    },
    {
        path: "/contract/quotation/history", //方案报价--访问记录
        component: (resolve) =>
            require(["@/views/contract/quotation/QuotationHistory.vue"], resolve),
        meta: {
            title: "报价方案",
            toBack: true,
        },
    },
    {
        path: "/ssl/test", //测试页面
        component: (resolve) =>
            require(["@/views/test/Test.vue"], resolve),
        meta: {
            title: "ssl测试",
            toBack: true,
        },
    },

];

var router = new VueRouter({
    mode: "history",
    routes,
});

router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
});

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    if (to.path !== "/") {
        storage.setStorage("path", to.fullPath);
    }

    next();
});
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js